import { render, staticRenderFns } from "./position_total.vue?vue&type=template&id=6ddc93f0&scoped=true&"
import script from "./position_total.vue?vue&type=script&lang=js&"
export * from "./position_total.vue?vue&type=script&lang=js&"
import style0 from "./position_total.vue?vue&type=style&index=0&id=6ddc93f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc93f0",
  null
  
)

export default component.exports